import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'

import WindUtilityOperator from './WindUtilityOperator'
import WindPlant from './WindPlant'

import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

import WindPowerData from './windpowerdata'
import WindInactive from './WindInactive'
import WindUnitAccess from './WindUnitAccess'
import WindSubgroup from './WindSubgroup'
import WindGadsError from './WindGadsError'

const WindContainer = ({ actionPermits, envConfig }) => {
  const windPoerDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA,
          ScreenPermissions.WIND_ADMIN_POWER_DATA,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const windAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {windAdminScreenAccess && (
        <React.Fragment>
          <Route exact path="/wind/wind-plant" component={WindPlant} />
          <Route
            exact
            path="/wind/wind-utility-operator"
            component={WindUtilityOperator}
          />
          <Route exact path="/wind/wind-inactive" component={WindInactive} />
          <Route
            exact
            path="/wind/wind-subgroup-access"
            component={WindUnitAccess}
          />
          <Route exact path="/wind/wind-subgroup" component={WindSubgroup} />
          <Route exact path="/wind/wind-error" component={WindGadsError} />
        </React.Fragment>
      )}
      {windPoerDataAccess && (
        <Route exact path="/wind/wind-power-data" component={WindPowerData} />
      )}
    </React.Fragment>
  )
}

export default WindContainer
